export default __webpack_public_path__ + "static/media/pagination_left_arrow.c79e8a74.svg";